import { render, staticRenderFns } from "./HotelSidebar.vue?vue&type=template&id=867e6f78&scoped=true"
import script from "./HotelSidebar.vue?vue&type=script&lang=js"
export * from "./HotelSidebar.vue?vue&type=script&lang=js"
import style0 from "./HotelSidebar.vue?vue&type=style&index=0&id=867e6f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867e6f78",
  null
  
)

export default component.exports